export const downloadImage = (url: string, name: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = name;

  document.body.appendChild(link);
  link.click();

  console.log(link)

  // document.body.removeChild(link);
};